import React from 'react';
import FaqBannerImg from "../../assets/images/resources/faq-banner-img.jpg"

function FaqBanner() {
  return (
    <div>
      <section className="faq-banner">
        <div className="container">
          <div
            className="faq-banner-img wow fadeInUp animated"
            data-wow-duration="1500ms"
            data-wow-delay="300ms"
          >
            <img
              src={FaqBannerImg}
              alt="faq-banner-img"
            />
          </div>
        </div>
      </section>
    </div>
  )
}

export default FaqBanner
